export const GET_PACKAGE = 'GET_PACKAGE';
export const GET_PACKAGEID = 'GET_PACKAGEID';
export const UPDATE_PACKAGE_LIST = 'UPDATE_PACKAGE_LIST';
